import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
}

const KlubPlayVideoIcon: NextPage<Props> = ({
  width = "100%",
  height = "100%",
  color = "#511010",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 120 120"
      fill="none"
    >
      <g filter="url(#filter0_dd_5592_62347)">
        <circle cx="60" cy="44" r="28" fill="white" />
        <path d="M68 44L56 50.9282L56 37.0718L68 44Z" fill="#3A3A3A" />
      </g>
      <defs>
        <filter
          id="filter0_dd_5592_62347"
          x="0"
          y="0"
          width="120"
          height="120"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5592_62347"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="16" />
          <feGaussianBlur stdDeviation="16" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_5592_62347"
            result="effect2_dropShadow_5592_62347"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_5592_62347"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default KlubPlayVideoIcon;
